import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
} from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { MergeFCService } from '../../services/raintree/Transmission/merge-fc.service';
import { MatIconModule } from '@angular/material/icon';
import { DialogRef } from '@angular/cdk/dialog';
import { DpSuccessMessageComponent } from '../../common-component/dp-success-message/dp-success-message.component';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-confirmation-merge',
  standalone: true,
  imports: [
    MatIconModule,
    MatDialogModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  templateUrl: './confirmation-merge.component.html',
  styleUrl: './confirmation-merge.component.scss',
})
export class ConfirmationMergeComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toaster: ToastrService,
    private mergeFCService: MergeFCService,
    private dialogRef: DialogRef<ConfirmationMergeComponent>,
    private dialog: MatDialog
  ) {}
  comment = new FormControl('');
  allowedKeys: any[] = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete'];
  mergedFcCount: number = 0;
  count: number = 0;
  ngOnInit() {
    this.comment.valueChanges.subscribe((value: any) => {
      if (value.length >= 1) this.count = value.length;
    });
    this.data.data.map((item: { added: any }) => {
      if (item.added) this.mergedFcCount++;
    });
    this.data.data = this.data.data.filter(
      (item: { added: boolean }) => item.added === true
    );
  }
  onMergeClick() {
    let fcData = this.data.data.map(
      (item: {
        family_code: any;
        last_istavrity_date: any;
        member_code: any;
        phl_mem_name: any;
        phl_mem_surname: any;
      }) => ({
        fc: item.family_code,
        lastIVDate: item.last_istavrity_date,
        mc: item.member_code,
        memName: item.phl_mem_name,
        sn: item.phl_mem_surname,
      })
    );
    let reqData = {
      // primaryFC: this.data.memCode,
      fcData: fcData,
      isFCRejected: false,
      comments: this.comment.value,
    };
    this.mergeFCService.addForMerge(this.data.slNo, reqData).subscribe({
      next: (response: any) => {
        if (!response.error) {
          this.dialogRef.close();
          this.dialog.open(DpSuccessMessageComponent, {
            panelClass: 'common-pannel-dialog-container',
            data: {
              mainHeading: 'Merged Codes Successfully',
              subHeading:
                'you can go to `Merge History` on FC merge page to check merged datas.',
              buttonValue: 'Finish',
            },
          });
        }
      },
      error: (error) => {
        this.toaster.error(error);
        this.dialogRef.close();
      },
    });
  }
  restrictInput(event: KeyboardEvent): void {
    const input = event.key;
    const limit = event.target as HTMLInputElement;

    if (
      this.allowedKeys.includes(input) ||
      event.ctrlKey ||
      event.altKey ||
      event.metaKey
    ) {
      return;
    }
    if (limit.value.length > 119) {
      event.preventDefault(); // Prevent input if it doesn't match the pattern
    }
  }
}
